import React from "react";

// componetns imports
import './header.css'

const Header = () => {
    return(
        <header className='header-area'>
            <h1>Events & News</h1>
            <h5>Learn, Compete and Grow</h5>
        </header>
    )
}

export default Header;